import { useState, useRef, useEffect } from "react";
import { Map } from "react-map-gl";
import maplibregl from "maplibre-gl";
import DeckGL from "@deck.gl/react";
import useMapState from "../states/MapState";
import SensorDataTooltip from "./SensorDataTooltip";
import DownloadDialog from "./DownloadDialog";
import { IconLayer } from "@deck.gl/layers";
import { SerialTimePanel } from "./SerialTimePanel";
import "maplibre-gl/dist/maplibre-gl.css";
import ResourceInfoDialog from "./ResourceInfoDialog";
import { usePlayingState } from "../states/PlayingState";

export default function DeckGLMap() {
  const {
    viewState,
    mapStyle,
    setViewState,
    layers,
    downloadDialogVisible,
    setDownloadDialogVisible,
    resourceInfoId,
    setResourceInfoId,
    containerRect,
    setContainerRect,
  } = useMapState();

  // Esto debería poder moverse dentro del SensorDataTooltip, al unmount, pero no funciona
  const { unSyncWithPath, syncedWithPath } = usePlayingState();

  const [hoverInfo, setHoverInfo] = useState(null);
  const [graphicMarker, setGraphicMarker] = useState(null);
  const [graphicPanelVisible, setGraphicPanelVisible] = useState(false);
  const mapContainerRef = useRef(null);

  // const [containerRect, setContainerRect] = useState({});

  const handleGraphichOpen = () => {
    setGraphicPanelVisible(true);
    setGraphicMarker({ ...hoverInfo.object });
  };

  const handleDrawerClose = () => {
    setGraphicPanelVisible(false);
  };

  useEffect(() => {
    if (mapContainerRef.current) {
      setContainerRect(mapContainerRef.current.getBoundingClientRect());
    }
  }, [mapContainerRef]);

  // Vigilamos desaparición de la capa de iconlayer para cerrar tooltip
  useEffect(() => {
    if (hoverInfo && hoverInfo.layer) {
      const layerId = hoverInfo.layer.id;
      const layerExists = layers.some((layer) => layer.id === layerId);
      if (!layerExists) {
        setHoverInfo(null);
        // Esto debería poder moverse dentro del SensorDataTooltip, al unmount, pero no funciona
        if (syncedWithPath) unSyncWithPath();
      }
    }
  }, [layers, hoverInfo]);

  const onViewStateChange = ({ viewState }) => {
    setViewState(viewState);
  };

  const onClick = (info) => {
    if (info.layer instanceof IconLayer && info.object) {
      let { userData } = info.layer.props;

      info.object = {
        ...info.object,
        ...userData,
      };
      setHoverInfo(info);
    }
  };

  return (
    <div
      ref={mapContainerRef}
      style={{ position: "relative", height: "100vh" }}
    >
      <DeckGL
        initialViewState={viewState}
        onViewStateChange={onViewStateChange}
        controller={true}
        layers={layers}
        onClick={onClick}
        getTooltip={({ object }) => object && object.tooltip}
        getCursor={({ isHovering, isDragging }) => {
          if (isDragging) {
            return "grabbing";
          }
          return isHovering ? "pointer" : "grab";
        }}
      >
        <Map
          reuseMaps
          mapLib={maplibregl}
          mapStyle={mapStyle}
          preventStyleDiffing={true}
        />
      </DeckGL>
      {hoverInfo && hoverInfo.object && (
        <div
          style={{
            position: "absolute",
            left: 10,
            top: 10,
          }}
        >
          <SensorDataTooltip
            onGraphichOpen={handleGraphichOpen}
            marker={hoverInfo.object}
            onClose={() => setHoverInfo(null)}
          />
        </div>
      )}
      {graphicPanelVisible && (
        <SerialTimePanel
          marker={graphicMarker}
          handleDrawerClose={handleDrawerClose}
        />
      )}
      <DownloadDialog
        visible={downloadDialogVisible}
        marker={graphicMarker}
        onCancel={() => setDownloadDialogVisible(false)}
      />
      <ResourceInfoDialog
        visible={!!resourceInfoId}
        optionId={resourceInfoId}
        onCancel={() => setResourceInfoId(false)}
      />
    </div>
  );
}
